import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  useToast,
  HStack,
} from '@chakra-ui/react';
import { FcGoogle } from 'react-icons/fc';
import { useAuth } from '../contexts/AuthContext';
import Logo from '../components/Logo';
import { Header } from '../components/Header';

export default function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSignIn = async () => {
    try {
      await signIn();
      navigate('/dashboard');
    } catch (error) {
      toast({
        title: 'Error signing in',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box>
      <Header />
      <Container maxW="container.sm" py={20}>
        <VStack spacing={8} align="center">
        <HStack spacing={2}>
          <Box width="32px">
            <Logo variant="icon" size="md" />
          </Box>
          <Heading size="md">emailed.app</Heading>
        </HStack>
        <Heading size="xl">Welcome Back</Heading>
        <Text>Sign in to access your email dashboard</Text>
        
        <Box w="full" maxW="md" p={8} borderWidth={1} borderRadius="lg">
          <Button
            w="full"
            size="lg"
            leftIcon={<FcGoogle />}
            onClick={handleSignIn}
            variant="outline"
          >
            Sign in with Google
          </Button>
        </Box>
        </VStack>
      </Container>
    </Box>
  );
}